import Vue from 'vue'

export const checkResponseErrors = async (response) => {
  console.log('response')
  console.log(response)
  if (response.status < 400) return false;
  const contentType = response.headers.get("content-type");

  let msg;
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const body = response.data;
    msg = body.Failed || response.message;
  } else {
    msg = response.body || response.message;
  }
  
  Vue.toasted.error(msg || "Server Error.", { duration: 5000 });
  return true;
}

const buildHeaders = (headers = {}) => Object.assign({
  'Content-Type': 'application/json',
  'apikey': localStorage.getItem('id_token')
}, headers);

const httpWithBody = (url, data, headers, method) => {
  return fetch(url, {
    method: method,
    mode: 'cors',
    headers: buildHeaders(headers),
    body: JSON.stringify(data)
  });
}

export const httpPost = (url, data, headers) => {
  return httpWithBody(url, data, headers, 'POST');
}

export const httpPut = (url, data, headers) => {
  return httpWithBody(url, data, headers, 'PUT');
}

export const httpDelete = (url, data, headers) => {
  return httpWithBody(url, data, headers, 'DELETE');
}

export const httpGet = (url, headers) => {
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: buildHeaders(headers)
  });
}

export const fixError = function(err) {

  if (err.response && err.response.data)
  {
    if (err.response.data.message) {
      return err.response.data.message;
    }
    else if (err.response.data.Failed) {
      return err.response.data.Failed;
    }
  }

  return Object.getOwnPropertyNames(err).reduce((acc, key) => { acc[key] = err[key]; return acc; }, {})
};


// WEBPACK FOOTER //
// ./src/utils/http.js